export enum FolderViewType {
    /** MyVideos grid view */
    MyVideosView = 'grid-view',
    /** Package wizard view for adding folders to packages */
    PackageView = 'package-view',
    /** Selected folder view within a package */
    SelectedFolderInPackage = 'selected-folder-in-package'
  }